const state = {
    type: null,
    message: null
};

const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    warning({ commit }, message) {
        commit('warning', message);
    },
    clear({ commit }, message) {
        commit('clear', null);
    }
};

const mutations = {
    success(state, message) {
        if (message){
            state.type = 'success';
            let finalMessage = message.data ? message.data.message : message
            state.message = finalMessage.toString();
        }
    },
    warning(state, message) {
        if (message){
            state.type = 'warning';
            let finalMessage = message.data ? message.data.message : message
            state.message = finalMessage.toString();
        }
    },
    error(state, message) {
        state.type = 'danger';
        console.error(message)

        if (message !== undefined){
            let finalMessage = message;
            if (message.message !== undefined){
                finalMessage = message.message;
            }
            if (message.data !== undefined){
                finalMessage = message.data.message || message.statusText;
            }
	        state.message = finalMessage;
        }
    },
    clear(state) {
        state.type = null;
        state.message = null;
    }
};

export const alert = {
    namespaced: true,
    state,
    actions,
    mutations
};